import React from 'react';
import loadingGif from '../assets/img/loading-pinwheel.gif';
import '../assets/css/components/iframe-wrapper.css';

const IFrameWrapper = props => {
  return(
    <div className='resp-iframe-container'>
      <img src={loadingGif}/>
      {props.children}
    </div>
  );
}

export default IFrameWrapper;
